import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, showNotification, refreshView as refreshViewAction } from 'react-admin';

import request from '../../../../network/request';
import resourceConfig from './config';

class GetOmsConnection extends Component {
  state = {
    executing: false,
  };
  handleClick = async () => {
    const { showNotification, record, refreshView } = this.props;

    this.setState({
      executing: true,
    });

    const { id } = record;
    let data = {
      id: id,
    };
    let url = '/admin/company_shoes_info/getOmsConnection';
    let response = null;
    try {
      response = await request({
        apiService: 'shoes',
        path: url,
        urlParams: data,
        method: 'POST',
      });
    } catch (e) {
      console.error(e);
    }
    if (response === null || !response.ok) {
      showNotification(`resources.${resourceConfig.name}.getOms.errorMessage`, 'error');
    } else {
      showNotification(`resources.${resourceConfig.name}.getOms.successMessage`, 'success');
    }

    this.setState(
      {
        executing: false,
      },
      refreshView,
    );
  };

  render() {
    return (
      <Button
        label={`resources.${resourceConfig.name}.getOms.action`}
        disabled={this.state.executing}
        onClick={this.handleClick}
      />
    );
  }
}

export default connect(undefined, {
  showNotification,
  refreshView: refreshViewAction,
})(GetOmsConnection);
